import { useContext } from 'react';
import { MultiStepFormContext, useForm } from '@kanda-libs/ks-component-ts';

import { FIELD_NAMES } from './constants';

export default function useAcceptDisclaimerForm() {
  const { data, handleContinue } = useContext(MultiStepFormContext);

  const { isLoading } = data || {};

  const form = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  const { watch } = form;

  const [acceptedDisclaimer, acceptedStandAlone] = watch(FIELD_NAMES);

  const nextButtonProps = {
    disabled: isLoading || !acceptedDisclaimer || !acceptedStandAlone,
  };

  const onSubmit = (submittedData) => {
    if (handleContinue) {
      handleContinue({ ...data, formData: submittedData });
    }
  };

  return {
    form,
    isLoading,
    nextButtonProps,
    onSubmit,
  };
}
